import { render } from "./promo-view.vue?vue&type=template&id=7d963472&scoped=true"
import script from "./promo-view.vue?vue&type=script&lang=js"
export * from "./promo-view.vue?vue&type=script&lang=js"

import "./promo-view.vue?vue&type=style&index=0&id=7d963472&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d963472"]])

export default __exports__